import { ConferenceType } from '@wui/im'

import { isGuest } from '@/shared/composables/local-storage'
import type { Contact } from '@/shared/types/api'
import type { RoomListItem } from '@/shared/types/app'

export const isContactInGroupRoom = (room: RoomListItem, contact: Contact) => {
  if (!room.isGroup) {
    return false
  }

  if (room.subscribers.has(contact.imLogin) || room.subscribers.has(contact.id)) {
    return true
  }

  for (const subscriber of room.subscribers.values()) {
    if (subscriber.imLogin === contact.imLogin || subscriber.id === contact.id) {
      return true
    }
  }

  return room.contacts?.some((member) => (
    member.id === contact.imLogin || member.id === contact.id
  )) ?? false
}

export const canAddMembersToRoom = (
  room: RoomListItem,
  currentUserImLogin?: string | null,
) => {
  if (isGuest() || !room.isGroup) {
    return false
  }

  if (room.mode !== ConferenceType.MODERATED) {
    return true
  }

  const myContact = room.contacts?.find((member) => member.id === currentUserImLogin)
  return myContact?.role === 'Owner' || myContact?.role === 'Moderator'
}

export const isEligibleGroupRoomForContact = (
  room: RoomListItem,
  contact: Contact,
  currentUserImLogin?: string | null,
) => (
  canAddMembersToRoom(room, currentUserImLogin)
  && !isContactInGroupRoom(room, contact)
)
